import { useState } from "react";
import { logEmployeeActivity } from "../utils/activityLogger";

const MASTER_PIN = "7324";
const MAX_ATTEMPTS = 3;

export default function MasterPinGate({ onVerified }) {
  const [pin, setPin] = useState("");
  const [error, setError] = useState("");
  const [attempts, setAttempts] = useState(0);

  const attemptsRemaining = Math.max(MAX_ATTEMPTS - attempts, 0);
  const isLocked = attempts >= MAX_ATTEMPTS;

  const handleSubmit = (event) => {
    event.preventDefault();

    if (isLocked) {
      setPin("");
      setError("Invalid Master PIN");
      return;
    }

    if (pin === MASTER_PIN) {
      setPin("");
      setError("");
      void logEmployeeActivity({
        action: "Master PIN Verified",
        module: "Master PIN",
        description: "Master PIN verification succeeded for secured access.",
      });
      onVerified();
      return;
    }

    const nextAttempts = attempts + 1;
    setAttempts(nextAttempts);
    setError("Invalid Master PIN");
    setPin("");
  };

  return (
    <div className="master-pin-shell">
      <div className="master-pin-gate-card">
        <div className="master-pin-gate-copy">
          <div className="master-pin-badge-row">
            <span className="master-pin-eyebrow">Restricted Access</span>
            <span className="master-pin-admin-chip">Admin Only</span>
          </div>
          <h1>Master PIN Management</h1>
          <p>
            Verify the 4-digit master PIN to open the employee access PIN dashboard.
          </p>
        </div>

        <form className="master-pin-gate-form" onSubmit={handleSubmit}>
          <label className="master-pin-label" htmlFor="master-pin-input">
            Enter Master PIN
          </label>
          <input
            id="master-pin-input"
            type="password"
            inputMode="numeric"
            pattern="[0-9]*"
            maxLength={4}
            autoComplete="off"
            className={`master-pin-input ${error ? "is-error" : ""}`}
            value={pin}
            disabled={isLocked}
            onChange={(event) => {
              setPin(event.target.value.replace(/\D/g, "").slice(0, 4));
              if (error) {
                setError("");
              }
            }}
            placeholder="0000"
            required
          />

          {error ? <p className="master-pin-error">{error}</p> : null}
          <p className={`master-pin-attempts ${isLocked ? "is-locked" : ""}`}>
            {isLocked
              ? "3 attempts used. Refresh the page to try again."
              : `${attemptsRemaining} attempts remaining`}
          </p>

          <button
            type="submit"
            className="master-pin-primary-button"
            disabled={isLocked}
          >
            Verify PIN
          </button>
        </form>
      </div>
    </div>
  );
}
